<template>
	<div class="team-edit">
		<div class="tm">※必須項目</div>

		<div class="input-wrap">
			<div class="input-title require">チーム名</div>
			<div class="sv-field">
				<input type="text" class="sv-input" :class="{ 'is-danger': $utils.hasError(errors, 'name') }" v-model="name"/>
			</div>
			<span class="error-message" v-show="errors.name">{{ errors.name }}</span>
			<div class="tm mt-5">末尾に「チーム」をつけてください</div>
		</div>

		<div class="input-wrap">
			<div class="input-title require">フリガナ</div>
			<div class="sv-field">
				<input type="text" class="sv-input" :class="{ 'is-danger': $utils.hasError(errors, 'nameKana') }" v-model="nameKana"/>
			</div>
			<span class="error-message" v-show="errors.nameKana">{{ errors.nameKana }}</span>
			<div class="tm mt-5">末尾に「チーム」をつけてください</div>
		</div>

		<div class="input-wrap">
			<div class="input-title">画像</div>
			<div class="sv-field" style="text-align: center;">
				<img class="preview" :src="imageBase" v-show="!image" :style="{ 'max-width': previewW + 'px' }">
				<image-picker :isDeleteButtonShow="false" :previewUrl="image" :isLoading="isImageLoading" :previewW="previewW" @file-change="onImageChange"></image-picker>
			</div>
		</div>

		<div class="input-wrap">
			<div class="input-title">チームの紹介文</div>
			<div class="sv-field">
				<b-input type="textarea" v-model="detail"></b-input>
			</div>
		</div>

		<horizontal-buttons class="mt-40" :okButtonTitle="type" :isOkButtonLoading="isSubmitLoading" @ok-click="isModalActive = true" @cancel-click="$router.go(-1)"></horizontal-buttons>

		<b-modal :active.sync="isModalActive">
			<confirm-modal :title="type + '確認'" :body="`チームを${type}します。よろしいですか？`" :okButtonTitle="type" @ok-click="onModalOkClick" @cancel-click="isModalActive = false"></confirm-modal>
		</b-modal>
	</div>
</template>

<script>
import ImagePicker from '@/components/ImagePicker'
import HorizontalButtons from '@/components/HorizontalButtons'
import ConfirmModal from '@/components/ConfirmModal'

export default {
	name: 'TeamEdit',
	components: {
		ImagePicker,
		HorizontalButtons,
		ConfirmModal,
	},
	data () {
		return {
			id: '',
			name: '',
			nameKana: '',
			detail: '',
			isImageLoading: false,
			isSubmitLoading: false,
			errors: {
				name: '',
				nameKana: '',
			},
			image: '',
			imageBase: '',
			previewW: 160,
			isModalActive: false,
		}
	},
	created() {
	},
	mounted() {
		this.init();
	},
	computed: {
		type: function() {
			return this.id ? '更新' : '作成';
		},
	},
	methods: {
		onModalOkClick: async function() {
			this.isModalActive = false;

			for (let key in this.errors) {
				this.errors[key] = '';
			}

			this.isSubmitLoading = true;
			let data = {
				"id": this.id,
				"name": this.name,
				"name_kana": this.nameKana,
				"detail": this.detail,
				"image": this.image,
			};
			this.$utils.log(data);

			let ep = 'teams';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.$router.push({ name: 'coin-present' });
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
				if (error.response.status === 400) {
					let details = error.response.data.details;
					for (let key in details) {
						this.errors[this.$utils.toCamelCase(key)] = details[key];
					}
				}
			} finally {
				this.isSubmitLoading = false;
			}
		},
		onImageChange: function(file) {
			this.uploadImage(file);
		},
		uploadImage: async function(file) {
			this.isImageLoading = true;

			let data = {
				"image": file,
			};
			let ep = 'teams/image';

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.image = res.data.url;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isImageLoading = false;
			}
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let params = this.$route.params.teamId ? '/' + this.$route.params.teamId : '';
			let ep = 'teams/screen' + params;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.id = res.data.id;
				this.name = res.data.name;
				this.nameKana = res.data.name_kana;
				this.image = res.data.image;
				this.imageBase = res.data.image_base;
				this.detail = res.data.detail;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
	}
}
</script>

<style lang="scss" scoped>
@import '@/scss/_vars.scss';

.preview {
	display: block;
	margin: 0 auto;
}

@media screen and (min-width: $breakPoint) {
	$sideMargin: 120px;

	.team-edit {
		margin-left: $sideMargin;
		margin-right: $sideMargin;
	}
}

</style>
